"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var required_1 = __importDefault(require("./required"));
var requiredBoolean_1 = __importDefault(require("./requiredBoolean"));
var cep_1 = __importDefault(require("./cep"));
var textCharsLength_1 = __importDefault(require("./textCharsLength"));
var cnpj_1 = __importDefault(require("./cnpj"));
var cpf_1 = __importDefault(require("./cpf"));
var date_1 = __importDefault(require("./date"));
var day_1 = __importDefault(require("./day"));
var minAge_1 = __importDefault(require("./minAge"));
var ddd_1 = __importDefault(require("./ddd"));
var email_1 = __importDefault(require("./email"));
var genericDocument_1 = __importDefault(require("./genericDocument"));
var legalAge_1 = __importDefault(require("./legalAge"));
var name_1 = __importDefault(require("./name"));
var nonNumeric_1 = __importDefault(require("./nonNumeric"));
var numeric_1 = __importDefault(require("./numeric"));
var phone_1 = __importDefault(require("./phone"));
var noSpecialCharacters_1 = __importDefault(require("./noSpecialCharacters"));
var customString_1 = __importDefault(require("./customString"));
var bankAccountNumber_1 = __importDefault(require("./bankAccountNumber"));
var sameValue_1 = __importDefault(require("./sameValue"));
var file_1 = __importDefault(require("./file"));
var nonRepeatedChars_1 = __importDefault(require("./nonRepeatedChars"));
var nonSequential_1 = __importDefault(require("./nonSequential"));
var numberRange_1 = __importDefault(require("./numberRange"));
var validators = {
  'required': required_1.default,
  'requiredboolean': requiredBoolean_1.default,
  'cep': cep_1.default,
  'cnpj': cnpj_1.default,
  'cpf': cpf_1.default,
  'day': day_1.default,
  'ddd': ddd_1.default,
  'email': email_1.default,
  'genericDocument': genericDocument_1.default,
  'legalAge': legalAge_1.default,
  'name': name_1.default,
  'nonNumeric': nonNumeric_1.default,
  'numeric': numeric_1.default,
  'phone': phone_1.default,
  'noSpecialCaracteres': noSpecialCharacters_1.default,
  'nonSequentialCharacters': nonSequential_1.default,
  // complex validators
  'minAge': minAge_1.default,
  'textCharsLength': textCharsLength_1.default,
  'customStringValidation': customString_1.default,
  'bankAccountNumber': bankAccountNumber_1.default,
  'file': file_1.default,
  'date': date_1.default,
  'sameValue': sameValue_1.default,
  'nonRepeatedChars': nonRepeatedChars_1.default,
  'numberRange': numberRange_1.default
};
exports.default = validators;